module.exports = __webpack_public_path__ + "static/jpmorgan-logo-30cabe99fb963177dd5e0fe37d130d50.png";